import TaiNguyenPage from "./TaiNguyenPage";

export default TaiNguyenPage